import { FileType } from "@/enums/FileType";
import { z } from "zod";

export const FileSchema = z.object({
    fileId: z.string(),
    dateStamp: z.coerce.date(),
    filename: z.string(),
    fileType: z.nativeEnum(FileType).nullable(),
  });
  
  export const FileListSchema = z.array(FileSchema);

  export type File = z.infer<typeof FileSchema>;
